module.exports = __webpack_public_path__ + "img/banner.9a266701.png";